import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Modal from './Modal';
import RiskQuestionnaire from './RiskQuestionnaire';

export default class RiskModal extends Component {
  state = {
    isOpen: false,
  };

  resetState = () =>
    this.setState(
      Object.keys(this.state).reduce((newState, key) => {
        newState[key] = false;

        return newState;
      }, {})
    );

  render() {
    const { isOpen } = this.state;
    const { riskResultChange } = this.props;

    return (
      <span>
        <StyledLink onClick={() => this.setState({ isOpen: true })}>
          {' '}
          <strong>{this.props.target}</strong>
        </StyledLink>
        <Modal open={isOpen} dimmerClick={this.resetState}>
          <CloseIcon onClick={() => this.setState({ isOpen: false })}>
            +
          </CloseIcon>
          <div style={{ paddingTop: '20px', paddingBottom: '20px' }}>
            <RiskQuestionnaire
              closeModal={() => this.setState({ isOpen: false })}
              riskResultChange={riskResultChange}
            />
          </div>
        </Modal>
      </span>
    );
  }
}

RiskModal.propTypes = {
  target: PropTypes.string.isRequired,
  riskResultChange: PropTypes.func,
};

RiskModal.defaultProps = {
  riskResultChange: () => {},
};

const StyledLink = styled.span`
  color: #2185d0;

  &:hover {
    color: #1e70bf;
    cursor: pointer;
  }
`;

const CloseIcon = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
  height: 20px;
  width: 20px;
  text-align: center;
  font-size: 1.7rem;
  border-radius: 50%;
  line-height: 19px;
  transform: rotate(45deg);
  transition: all 0.1s ease;
  cursor: pointer;

  &:hover {
    background: rgba(0, 0, 0, 0.8);
    color: #fff6f6;
  }
`;
